<nav class="sidebar" *ngIf="auth.isLogin()">
  <div class="sidebar-header">

    <!-- Logo -->
    <a routerLink="/" class="sidebar-brand">
      <img *ngIf="(themeService.theme$ | async) === 'light'" src="assets/images/Operator-new.jpg" alt="logo operator">
      <img *ngIf="(themeService.theme$ | async) === 'dark'" src="assets/images/Operator-dark.png" alt="logo operator dark">
    </a>

    <!-- Desktop: collapse chevron -->
    <button class="sidebar-toggle-btn"
            [class.collapsed]="isFolded"
            (click)="toggleSidebar($event)"
            title="Colapsar sidebar">
      <i data-feather="chevrons-left" appFeatherIcon></i>
    </button>

  </div>
  <div class="sidebar-body"
       (mouseenter)="operSidebarFolded()"
       (mouseleave)="closeSidebarFolded()"
       [perfectScrollbar]>

    <ul class="sidebar-nav" id="sidebar-menu" *ngIf="isConteinsRoles()" #sidebarMenu>
      <ng-container *ngFor="let item of getMenu(); let i = index">

        <!-- Section header (only if section has visible items) -->
        <li class="nav-item nav-category"
            *ngIf="item.isTitle && hasSectionVisibleItems(i)"
            [style.animation-delay.ms]="getStaggerDelay(i)">
          {{ item.label }}
        </li>

        <!-- Menu item -->
        <li class="nav-item"
            *ngIf="!item.isTitle"
            [style.animation-delay.ms]="getStaggerDelay(i)">

          <!-- Parent with subItems -->
          <a class="nav-link"
             *ngIf="hasItems(item)"
             href="javascript:void(0);"
             (click)="toggleSubMenu($event)">
            <i class="link-icon" [attr.data-feather]="item.icon" appFeatherIcon *ngIf="item.icon"></i>
            <span class="link-title">{{ item.label }}</span>
            <span class="badge" *ngIf="item.dynamic && item.subItems?.length">{{ item.subItems.length - 1 }}</span>
            <span class="link-arrow" data-feather="chevron-down" appFeatherIcon></span>
          </a>

          <!-- Simple link -->
          <a class="nav-link nav-link-ref"
             [routerLink]="item.link"
             *ngIf="!hasItems(item) && hasItemPermiso(item)"
             [attr.data-parent]="item.parentId">
            <i class="link-icon" [attr.data-feather]="item.icon" appFeatherIcon *ngIf="item.icon"></i>
            <span class="link-title">{{ item.label }}</span>
          </a>

          <!-- Submenu (tree indent) -->
          <ul class="sidebar-nav sub-menu" *ngIf="hasItems(item)" aria-expanded="false">
            <li class="nav-item" *ngFor="let subitem of item.subItems">
              <a class="nav-link nav-link-ref"
                 [routerLink]="subitem.link"
                 [attr.data-parent]="subitem.parentId"
                 [title]="subitem.label">
                <span class="link-title">{{ subitem.label }}</span>
              </a>
            </li>
          </ul>
        </li>

      </ng-container>
    </ul>

  </div>
</nav>
